import React from "react";
import { Button as ButtonAntd, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

const Icon = styled(ButtonAntd)`
  &.ant-btn {
    box-shadow: none !important;
    font-size: 12px;
  }
  background-color: ${({ status, theme }) =>
    status === "open"
      ? "#EBEFFF"
      : status === "published"
      ? theme["@primary"]
      : theme["@gray-30"]} !important;
  border-color: white !important;
  color: ${({ status, theme }) =>
    status === "open"
      ? theme["@primary"]
      : status === "published"
      ? "white"
      : theme["@gray-60"]} !important;

  &:hover {
    cursor: default !important;
  }
`;
const StatusIcon = ({ status }) => {
  const { t } = useTranslation();
  return (
    <Tooltip
      title={`${t("global:opportunity")} ${t(
        `opportunity:statuses.${status}`
      )}`}
    >
      <Icon
        status={status}
        type="primary"
        shape="circle"
        icon={
          status === "published"
            ? "check"
            : status === "open"
            ? "edit"
            : "close"
        }
      />
    </Tooltip>
  );
};

export default StatusIcon;
